import { createTheme } from "@mui/material/styles";

const textPrimary = "#000000";
const textDisabled = "#929292";

const theme = createTheme({
  typography: {
    allVariants: {
      color: textPrimary,
    },
    fontFamily: `'Poppins', sans-serif`,
  },
  palette: {
    colors: {
      grey1: `#D9D9D9`,
    },
    primary: {
      main: "#2B52D2",
      red: "#D22B2B",
      green: "#2BD24C",
      orange: "#D25B2B",
    },
    secondary: {
      main: "#FF6F20",
    },
    border: {
      main: "#2B52D299",
      disabled: "#929292",
      white: "#ffffff",
    },
    background: {
      default: "#EFEFEF",
      paper: "#FFFFFF",
      card: "#F8F9F9",
    },
    text: {
      form: "#23262C",
      // primary: "#23262C",
      secondary: "#FFFFFF",
      primary: textPrimary,
      // secondary: "#FFFFFF",
      disabled: textDisabled,
      highlight: "#2B52D2",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          // This sets the text to have the first letter capitalized
          // and the rest of the letters lowercase, which is the default
          // behavior of 'capitalize' in CSS/MUI.
          textTransform: 'capitalize', 
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: textPrimary, // or use theme.palette.text.default
          "&.Mui-disabled": {
            color: textDisabled, // for disabled state
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          color: `${textPrimary}`,
          [`& .MuiOutlinedInput-root`]: {
            // Specifically for outlined variant
            color: `${textPrimary}`,
            [`& .MuiOutlinedInput-input`]: {
              // Specifically for outlined variant
              color: `${textPrimary}`,
            },
          },
          [`& .MuiInputBase-root`]: {
            [`& .MuiInputAdornment-root`]: {
              [`& .MuiTypography-root`]: {
                color: `${textPrimary}`,
              },
              color: `${textPrimary}`,
            },
            // Specifically for outlined variant
            color: `${textPrimary}`,
            [`& .MuiInputBase-input`]: {
              // Specifically for outlined variant
              color: `${textPrimary}`,
            },
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: textPrimary, // Set the default color for FormLabel
          "&.Mui-focused": {
            // color: "#2B52D2", // Set the color when the associated input is focused
          },
          "&.Mui-disabled": {
            color: textDisabled, // Set the color when the FormLabel is disabled
          },
          "&.Mui-error": {
            // color: "#d32f2f", // Example: Set an error color
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: "none",
        },
      },
    },
    // MuiTypography: {
    //   styleOverrides: {
    //     root: {
    //       color: textPrimary, // Example: Set a general default for all Typography
    //     },
    //   },
    // },
  },
});

export default theme;
